import { IOnInit } from "angular";
import {
  AssetClassNames,
  AssetClassNameArray,
} from "../../../common/enums/AssetClassType";
import { CModelRepo } from "../../../cmodel/cmodel.repo";
import { FeesRepo } from "../../fees.repo";
import { PortfolioRepo } from "../../../portfolio/portfolio.repo";

class CreatePortfolioFeeExclusionDialogController implements IOnInit {
  public portfolioId: number;
  public portfolioName: string;
  public assetClassNames = AssetClassNameArray.filter(
    (assetClassName) => assetClassName != AssetClassNames.CASH
  );
  public selectedAssetClass;
  public portfolioFeeExclusionForm: ng.IFormController;
  public securitiesList;
  public isLoadingSecurities: boolean = false;
  public excludeMarketValue: boolean = false;
  public selectedSecurity;
  public marketValue: number;
  public toDate: Date;
  public fromDate: Date;
  public searchText: any = "";
  public hasPortfolioInSecurity: boolean = true;

  /** @ngInject */
  constructor(
    private $mdDialog: angular.material.IDialogService,
    private cModelRepo: CModelRepo,
    private feesRepo: FeesRepo,
    private notifyjs,
    private portfolioRepo: PortfolioRepo
  ) {}

  $onInit() {}

  getSecurities = () => {
    if (this.selectedAssetClass) {
      this.isLoadingSecurities = true;
      this.securitiesList = [];
      if (this.hasPortfolioInSecurity) {
        this.portfolioRepo
          .getPortfolioSecurities(this.portfolioId, this.selectedAssetClass)
          .then((res) => {
            this.isLoadingSecurities = false;
            this.securitiesList = res.data;
          })
          .catch((err) => {
            this.isLoadingSecurities = false;
          });
      } else {
        this.cModelRepo
          .getSecurityItemsList(this.selectedAssetClass, null, false)
          .then((res) => {
            this.isLoadingSecurities = false;
            this.securitiesList = res;
          })
          .catch((err) => {
            this.isLoadingSecurities = false;
          });
      }
    }
  };

  cancel = () => {
    this.$mdDialog.cancel();
  };

  save = () => {
    const actualFromDate = new Date(
      Date.UTC(
        this.fromDate.getFullYear(),
        this.fromDate.getMonth(),
        this.fromDate.getDate()
      )
    );

    const actualtoDate =
      this.toDate != null
        ? new Date(
            Date.UTC(
              this.toDate.getFullYear(),
              this.toDate.getMonth(),
              this.toDate.getDate()
            )
          )
        : null;

    let portfolioFeeExclusion = {
      portfolioId: this.portfolioId,
      securityId: this.selectedSecurity.id,
      excludeMarketValue: this.excludeMarketValue,
      marketValue: this.excludeMarketValue ? 0 : this.marketValue,
      fromDate: actualFromDate,
      toDate: actualtoDate,
    };

    this.feesRepo
      .savePortfolioFeeExclusion(portfolioFeeExclusion)
      .then((res) => {
        this.$mdDialog.cancel(portfolioFeeExclusion.portfolioId);
      })
      .catch((err) => {
        this.notifyjs("Failed to save fee exclusion : " + err.data);
      });
  };

  clearSearchText = () => {
    this.searchText = "";
  };
}

export const createPortfolioFeeExclusionDialog: angular.IComponentOptions = {
  template: require("./createPortfolioFeeExclusion.dialog.html"),
  controller: CreatePortfolioFeeExclusionDialogController,
  bindings: {
    portfolioId: "<",
    portfolioName: "<",
  },
};



// WEBPACK FOOTER //
// ./src/app/fees/clientFeeManagement/createFeeExclusion/createPortfolioFeeExclusion.dialog.ts